import React from 'react';



type Props = {
  className?: string;
};
export const PhotoGalleryVector: React.FC<Props> = ({ className }) => {
  return (
    <svg className = {className} width = '32' height = '32' viewBox = '0 0 32 32' fill = 'none' xmlns='http://www.w3.org/2000/svg'>
      <path fill = '#0041A0' d = 'M24 8V20H12V8H24ZM24 6H12C10.9 6 10 6.9 10 8V20C10 21.1 10.9 22 12 22H24C25.1 22 26 21.1 26 20V8C26 6.9 25.1 6 24 6ZM15.5 15.67L17.19 17.93L19.67 14.83L23 19H13L15.5 15.67ZM6 10V24C6 25.1 6.9 26 8 26H22V24H8V10H6Z' />
    </svg>
  );
};